import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTeamPhoto, usePersonalPhoto } from '../hooks';

const TopDiyList = ({ items, isCard, showLink, eventId }) => {
  const classList = classNames({
    box: isCard,
  });

  return items.map((item, index) => {
    let photo, buttonLink;

    if (item.consId) {
      /* eslint-disable */
      const personalPhoto = usePersonalPhoto(eventId, item.consId);
      /* eslint-enable */
      photo = personalPhoto.data.customUrl;
      buttonLink = item.donationLink;
    } else {
      /* eslint-disable */
      const teamPhoto = useTeamPhoto(eventId, item.captainConsId);
      /* eslint-enable */
      photo = teamPhoto.data.customUrl;
      //Hot fix for join buttons
      //There is some issue with the diy page wrapper pointing for diy_register that is is displaying incorrectly that I could not remediate
      if (item.eventType === 'diy'){
        buttonLink = `SPageServer?pagename=${item.eventType}_registration&fr_id=${item.eventId}&fr_rtype=join&fr_tjoin=${item.teamId}`;
      }
      else{
        buttonLink = `SPageServer?pagename=${item.eventType}_register&fr_id=${item.eventId}&fr_rtype=join&fr_tjoin=${item.teamId}`;
      }
      
    }

    return (
      <div className={classList} key={index}>
        <div className="columns mb-0 is-vcentered">
          <div className="column py-0">
            <div className="columns mb-0 is-flex">
              <div className="column p-0 global-leaderboard-name is-flex">
                {photo && photo.includes(eventId) ? (
                  <div className="global-leaderboard-initials is-narrow" style={{ backgroundImage: `url(${photo})` }}></div>
                ) : (
                  <div className="global-leaderboard-initials is-narrow">{item.initials}</div>
                )}
                <p className="has-text-weight-bold my-0">
                  <a href={item.pageLink}>{item.title}</a>
                </p>
              </div>
            </div>
          </div>
          <div className="column py-0">
            <div className="columns mb-0 is-flex">
              <div className="column global-leaderboard-raised">
                <p className="my-0">
                  <span className="is-hidden-tablet">
                    Amount raised:
                    <br />
                  </span>{' '}
                  {item.subtitle}
                </p>
              </div>
              {showLink &&
                (item.buttonText ? (
                  <div className="column has-text-right global-leaderboard-button">
                    <a aria-label={`link to ${item.title}`} href={buttonLink} className="button is-link is-donate is-small">
                      {item.buttonText}
                    </a>
                  </div>
                ) : (
                  <div className="column">
                    <a href={item.link} className="button is-white">
                      <span className="icon is-small">
                        <i className="svg-icon right-arrow-icon is-info"></i>
                      </span>
                    </a>
                  </div>
                ))}
            </div>
          </div>
        </div>
        {index < items.length - 1 ? <hr /> : ''}
      </div>
    );
  });
};

TopDiyList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string,
      donationLink: PropTypes.string,
      pageLink: PropTypes.string,
      buttonText: PropTypes.string,
      initials: PropTypes.string,
      consId: PropTypes.string,
      captainConsId: PropTypes.number,
      eventId: PropTypes.string,
      eventType: PropTypes.string,
      defaultImg: PropTypes.string,
    })
  ).isRequired,
  showLink: PropTypes.bool,
  isCard: PropTypes.bool,
};

TopDiyList.defaultProps = {
  showLink: false,
  isCard: false,
};

export default TopDiyList;
